<template>
  <div class="StyleSelectBar">
    <dl class="StyleSelectList">
      <template v-for="(style, idx) in categoryList">
        <dt
          class="SelectBar"
          :key="style.category"
          @click="toggleDropdown(idx)"
        >{{ style.title }}</dt>
        <dd
          class="select-bar_container"
          :class="{opened: false}"
          ref="dropdowns"
          :key="`${style.category}_dd`"
        >
          <ul class="select-bar_list">
            <li
              v-for="{name, id} in style.method"
              :key="id"
              class="select-bar_item"
            ><a @click.prevent="goSvgTableView(id)">{{ name }}</a></li>
          </ul>
        </dd>
      </template>
    </dl>
    <footer class="footnav_container">
      <SvgTableFooter v-bind="{preId, nextId}" />
    </footer>
  </div>
</template>

<script>
import jump from 'jump.js'
import SvgTableFooter from './SvgTableFooter.vue'
import { mapGetters } from 'vuex'

export default {
  name: 'StyleSelectBar',
  components: {
    SvgTableFooter
  },
  computed: {
    categoryList () {
      return this.$store.getters.categoryList
    },
    ...mapGetters(['preId', 'nextId'])
  },
  methods: {
    toggleDropdown (idx) {
      const listContainer = this.$refs.dropdowns[idx]
      listContainer.classList.toggle('opened')
      if (Array.from(listContainer.classList).includes('opened')) {
        jump(listContainer, {
          duration: 500,
          offset: -80,
          // callback: undefined,
          // easing: easeInOutQuad,
        })
      }
    },
    goSvgTableView (id) {
      window.requestAnimationFrame(() => {
        this.$router.push({name: 'SvgTableView', params: {id: id, at: 1}})
      })
    }
  },
  beforeRouteUpdate(to, from, next) {
    this.$store.commit('SET_ITEM', to.params)
    if (to.name === from.name) {
      for (const dropdown of this.$refs.dropdowns) {
        dropdown.classList.remove('opened')
      }
    }
    next()
  }
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
.StyleSelectList {
  display: flex;
  flex-flow: column nowrap;
  padding: 0;
  margin: 0;
  background-color: #fff;
}
.SelectBar {
  display: flex;
  justify-content: center;
  align-items: center;
  font-size: 1.2rem;
  width: 100%;
  min-height: 80px;
  border-bottom: 1px solid #727171;
}
.select-bar_container {
  scroll-margin-top: 80px;
  background-color: #f5f5f5;
  border-bottom: 1px solid #ddd;
}
.select-bar_container:not(.opened) {
  display: none;
}
.select-bar_list {
  display: block;
  margin: 0 auto;
  padding: 8px 16px;
  width: fit-content;
  max-width: max-content;
}
.select-bar_item {
  display: block;
  margin-bottom: 12px;
  color: #717171;
  font-weight: 800;
  line-height: 1.5;
  text-align: left;
  word-break: keep-all;
  line-break: strict;
  word-wrap: break-word;
  overflow-wrap: break-word;
}
.select-bar_item:last-child {
  margin-bottom: 0;
}
.select-bar_item > a:active {
  opacity: 0.5;
}
.footnav_container {
  position: sticky;
  left: 0;
  bottom: 0;
  z-index: 100;
  width: 100%;
  height: 48px;
  /* padding-top: 8px; */
  background-color: var(--main-color);
}
@media screen and (orientation: landscape) {
  .footnav_container {
    height: calc(env(safe-area-inset-bottom) + 48px);
    padding-left: env(safe-area-inset-left);
    padding-right: env(safe-area-inset-right);
  }
}
</style>



// WEBPACK FOOTER //
// src/components/StyleSelectBar.vue